var EventEmitterMixin = require("../../mixins/event-emitter.mixin");

var WishlistEntry = function () {
    var self = this;
    var $currentContext = $();

    // TODO-VTA: check tier price
    var classMap = {
        format: ".js-wishlist-entry__format",
        price: ".js-wishlist-entry__unit-price",
        addToCartCheckbox: ".js-wishlist-entry__add-to-cart-checkbox",
        removeButton: ".js-wishlist-entry__remove-button"
    };

    var $format, $unitPrice, $addToCartCheckbox, $removeButton;

    this.getCurrentFormat = function() {
        var $selectedFormatOption =  $format.children("option:selected");
        if($selectedFormatOption.length) {
            var selectedFormatOptionData = $selectedFormatOption.data();
            var formatData = $format.data();

            var format = {
                id: +$selectedFormatOption.val(),
                hasTierPrice: selectedFormatOptionData.hasTierPrice === "True",
                unitPrice: selectedFormatOptionData.unitPrice,
                priceCodeId: +formatData.priceCodeId,
                productId: this.getProduct().id
            };
            return format;
        } else {
            return null;
        }
    }

    this.getProduct = function() {
        var data = $currentContext.data();
        return {
            id: data.productId,
            name: data.productName,
            logoUrl: data.productLogoUrl
        }
    }

    this.setPrice = function(value) {
        $unitPrice.html(value);
    }

    this.getAddToCartMarker = function() {
        return $addToCartCheckbox.prop("checked");
    }

    this.setAddToCartMarker = function(value) {
        $addToCartCheckbox.prop("checked", value);
    }

    function bindEvents() {
        $format.on("change", function (e) {
            var currentFormat = self.getCurrentFormat();
            self._raiseEvent("format-changed", currentFormat);
        });
        $removeButton.on("change", function (e) {
            self._raiseEvent("entry-removed");
        });
        $addToCartCheckbox.on("change", function() {
            self._raiseEvent("add-to-cart-changed");
        });
    }

    function parseContext() {
        $format = $(classMap.format, $currentContext);
        $unitPrice = $(classMap.price, $currentContext);
        $addToCartCheckbox = $(classMap.addToCartCheckbox, $currentContext);
        $removeButton = $(classMap.removeButton, $currentContext);
    }

    this.initValue = function() {
        $format.change();
    }

    this.init = function (context) {
        $currentContext = context || $currentContext;

        parseContext();
        bindEvents();
    };
};

Object.assign(WishlistEntry.prototype, new EventEmitterMixin());

Object.defineProperty(WishlistEntry, "SELECTOR", {
    enumerable: false,
    configurable: false,
    writable: false,
    value: ".js-wishlist-entry"
});

module.exports = WishlistEntry;
